import {
	MatDialogRef,
	MAT_DIALOG_DATA,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { User } from 'src/app/models/data/user';
import { Company } from 'src/app/models/data/company';
import { ApiService } from 'src/app/services/api.services';
import { NgClass, NgPlural, NgPluralCase } from '@angular/common';
import { MatDivider } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
	selector: 'app-reactivate-user-dialog',
	templateUrl: './reactivate-user-dialog.component.html',
	styleUrls: ['./reactivate-user-dialog.component.scss'],
	imports: [
		NgClass,
		MatDivider,
		MatIcon,
		CdkScrollable,
		MatDialogContent,
		NgPlural,
		NgPluralCase,
		MatDialogActions,
	],
})
export class ReactivateUserDialogComponent implements OnInit {
	step: number = 0;
	errorAddingUser: boolean = false;
	listOfUserNames: string = '';

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AddingUserDialogData,
		private readonly dialogRef: MatDialogRef<AddingUserDialogData>,
		private readonly apiService: ApiService
	) {}

	ngOnInit(): void {
		if (this.data.users) {
			const listOfUserNamesArr = this.data.users.map(
				(user) => user.firstName + ' ' + user.lastName
			);
			this.listOfUserNames = this.formatListWithCommas(listOfUserNamesArr);
		}
	}

	onAddClicked(): void {
		const userIds = this.data.users.map((it) => it.id);
		this.apiService
			.assignRoleToUserId(userIds, this.data.roleId, this.data.company.id)
			.then((_) => {
				this.step++;
			})
			.catch((err) => {
				this.errorAddingUser = true;
			});
	}

	onCloseClicked(refresh: boolean): void {
		this.dialogRef.close(refresh);
	}

	formatListWithCommas(items: string[]): string {
		if (!items || items.length === 0) {
			return '';
		} else if (items.length === 1) {
			return items[0];
		} else if (items.length === 2) {
			return items.join(' and ');
		} else {
			return items.slice(0, -1).join(', ') + ', and ' + items[items.length - 1];
		}
	}
}

export interface AddingUserDialogData {
	users: User[];
	roleName: string;
	company: Company;
	roleId: string;
}
